import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
    selector: 'app-embed',
    templateUrl: './embed.component.html',
    styleUrls: ['./userpanel.component.css']
})
export class EmbedComponent implements OnInit {

    @Input() public item: string;
    @Input() public type: string;
    public videoLink;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
      this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.item);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/feed/embed/embed.component.ts